module.exports = __webpack_public_path__ + "static/flags/TN-e6e472a77f9e843acbc186ff9f024cb8.gif";